import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/common.less'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$baseUrl = `https://cgq.whnjk365.com/`

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
